export const contentfulImageToOgImage = (url: string): string =>
  `${url.startsWith('//') ? 'https:' : ''}${url}?w=1200&h=630&q=90&fit=fill&fm=jpg&bg=rgb:E9EBEE`
